import { useState } from "react";
import { useAuth } from "../lib/auth";
import {
  isPushEnabled,
  pushSupported,
  subscribeToPush,
  unsubscribeFromPush,
  vapidKey,
} from "../lib/push";

export default function Settings() {
  const { user } = useAuth();
  // Enabled = permission granted AND not opted out on this device.
  const [enabled, setEnabled] = useState(isPushEnabled());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function enable() {
    setBusy(true);
    setError(null);
    const res = await subscribeToPush();
    if (!res.ok) setError(res.error ?? "Failed");
    setEnabled(isPushEnabled());
    setBusy(false);
  }

  async function disable() {
    setBusy(true);
    setError(null);
    await unsubscribeFromPush();
    setEnabled(isPushEnabled());
    setBusy(false);
  }

  return (
    <div className="mx-auto max-w-lg">
      <p className="eyebrow text-signature">Settings</p>
      <h1 className="mt-1 text-2xl font-bold tracking-tight">Notifications</h1>

      <div className="mt-6 rounded-[10px] border border-line bg-white p-5">
        <h2 className="text-sm font-semibold text-ink">Push notifications</h2>
        <p className="mt-1 text-[13px] leading-relaxed text-ink-soft">
          Get notified when you're assigned a checklist item, when someone completes an item
          assigned to you, and when you're @mentioned in a comment.
        </p>
        <div className="mt-4 flex items-center gap-3">
          {!pushSupported() ? (
            <span className="font-mono text-[11px] text-muted">
              Not supported on this browser.
            </span>
          ) : !vapidKey ? (
            <span className="font-mono text-[11px] text-flag">
              Push not configured (missing VAPID key).
            </span>
          ) : enabled ? (
            <>
              <span className="badge bg-[#e6f4ea] text-positive">enabled</span>
              <button onClick={() => void disable()} disabled={busy} className="btn-secondary text-xs">
                Disable on this device
              </button>
            </>
          ) : (
            <button onClick={() => void enable()} disabled={busy} className="btn-primary text-xs">
              {busy ? "Enabling…" : "Enable notifications"}
            </button>
          )}
        </div>
        {error && <p className="mt-3 font-mono text-[11px] text-muted">{error}</p>}
      </div>

      <div className="mt-4 rounded-[10px] border border-line bg-white p-5">
        <h2 className="text-sm font-semibold text-ink">Account</h2>
        <p className="mt-1 font-mono text-[11px] text-muted">{user?.email}</p>
      </div>
    </div>
  );
}
